export const FETCH_PARTICIPANTS_STARTED = 'FETCH_PARTICIPANTS_STARTED';
export const FETCH_PARTICIPANTS_SUCCESS = 'FETCH_PARTICIPANTS_SUCCESS';
export const FETCH_PARTICIPANTS_FAILED = 'FETCH_PARTICIPANTS_FAILED';
